/*eslint no-var: [2] */

import PropTypes from 'prop-types';

import React from 'react';
import DynamicTextArea from '../../../dynamic_text_area.jsx';

let nextId = 1;

class Reply extends React.Component {
    static propTypes = {
        replyTo: PropTypes.func.isRequired,
        note: PropTypes.object.isRequired,
    };

    state = {
        id: 'reply-' + nextId++,
        reply_text: '',
        submitDisabled: true,
    };

    onChange = e => {
        const reply_text = e.target.value;

        this.setState({
            submitDisabled: reply_text.trim().length === 0,
            reply_text,
        });
    };

    handleSubmit = e => {
        const { reply_text, submitDisabled } = this.state;
        const { note, replyTo } = this.props;
        e.preventDefault();
        if (!submitDisabled) {
            replyTo(note, reply_text);
        }
    };

    render() {
        const { reply_text, submitDisabled } = this.state;

        return (
            <form onSubmit={this.handleSubmit}>
                <label htmlFor={this.state.id}>Reply to this question</label>
                <DynamicTextArea
                    name="note_text"
                    required="required"
                    id={this.state.id}
                    aria-required="true"
                    value={reply_text}
                    onChange={this.onChange}
                />
                <button
                    disabled={submitDisabled}
                    className="btn btn-primary"
                    type="submit"
                >
                    Add Reply
                </button>
            </form>
        );
    }
}

export default Reply;



// WEBPACK FOOTER //
// ./src/components/all_notes/chapter/note/reply.jsx